// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"_3HD6PhnF36","tableHeader":"ZxlFRHkL0-","sticky":"_1Z9ns1hlRt","clickable":"_1rnxEq4zmE","sortIcon":"_3UQ7HFuTJ7","sortable":"_2yOArNgJcW"};